export function CompanyPartner() {
  return (
    <section className="px-4 py-[72px] desktop:py-[120px] bg-[#283241]">
      <div className="max-w-[1150px] mx-auto">
        <div className="flex flex-col gap-6 tablet:flex-row tablet:items-center">
          <div>
            <h2 className="text-heading-1-mb desktop:text-heading-1 text-white">
              채권추심 파트너사
            </h2>
            <div className="mt-2 text-body-2-mb desktop:text-body-2 !font-normal text-white">
              <p>
                새한신용정보주식회사는 1968년 창업하여 50여년간 꾸준히
                신용정보업계를 주도하며 성장하여 왔습니다.
              </p>
              <p>
                국내 신용정보회사로서는 전국에 최대의 점포망을 구축하여 최고의
                실력을 갖춘 신용관리사가 추심하므로 괄목할 만한 성과를 거두어
                고객이 만족하는 신용정보사로 자리잡고 있습니다.
              </p>
            </div>
          </div>
          <div className="py-4 bg-white rounded-2xl flex flex-col items-center gap-[10px] min-w-[363px]">
            <img
              src="https://vws-front-store.s3.ap-northeast-2.amazonaws.com/company/shci.webp"
              alt="shci"
              className="h-[138px] tablet:h-[158px] desktop:h-[158px]"
            />
            <span className="text-heading-2-mb desktop:text-heading-2 text-[#212121]">
              새한신용정보 (주)
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
